//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { apiurl } from '@/config';

class _AstaClient {

    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Asta> {
                        return CommonServices.defaultGet<OM.Asta>(apiurl + 'api/Asta/GetById',{ identifier }, showSpinner);

                    }
    

                
            getImportedAste(showSpinner = true): Promise<{ [key: string]: string; }> {
                        return CommonServices.defaultGet<{ [key: string]: string; }>(apiurl + 'api/Asta/GetImportedAste',{  }, showSpinner);

                    }
    

                
            importInOnOffice(
                astaIdentifier:string,showSpinner = true): Promise<OM.ImportAstaResponse> {
                        return CommonServices.defaultGet<OM.ImportAstaResponse>(apiurl + 'api/Asta/ImportInOnOffice',{ astaIdentifier }, showSpinner);

                    }
    

                
            getValori(
                property:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Asta/GetValori',{ property }, showSpinner);

                    }
    

                
            getByFilterVm(
                vm:OM.GetAsteFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfAstaForListVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfAstaForListVm>(apiurl + 'api/Asta/GetByFilterVm', vm,{}, showSpinner );

                    }
    }

export let AstaClient = new _AstaClient();

class _LoginClient {

    

                
            login(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/Login',{  }, showSpinner);

                    }
    

                
            refreshLogin(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/RefreshLogin',{  }, showSpinner);

                    }
    

                
            loginFromOnOffice(
                userId:string,
                customerWebId:string,
                apiClaim:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/LoginFromOnOffice',{ userId, customerWebId, apiClaim }, showSpinner);

                    }
    }

export let LoginClient = new _LoginClient();

class _MarketplaceClient {

    

                
            checkSignature(
                message:string,
                signature:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Marketplace/CheckSignature',{ message, signature }, showSpinner);

                    }
    

                
            getSignature(
                message:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Marketplace/GetSignature',{ message }, showSpinner);

                    }
    

                
            activateMarketplace(
                userSecretKey:string,
                apiToken:string,
                apiClaim:string,
                parameterCacheId:string,
                userId:string,
                customerWebId:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Marketplace/ActivateMarketplace',{ userSecretKey, apiToken, apiClaim, parameterCacheId, userId, customerWebId }, showSpinner);

                    }
    

                
            checkActivation(
                customerWebId:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Marketplace/CheckActivation',{ customerWebId }, showSpinner);

                    }
    

                
            updateApiClaim(
                webUserId:string,
                newApiClaim:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Marketplace/UpdateApiClaim',{ webUserId, newApiClaim }, showSpinner);

                    }
    }

export let MarketplaceClient = new _MarketplaceClient();

class _QuartzClient {

    

                
            startJobNow(showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Quartz/StartJobNow',{  }, showSpinner);

                    }
    }

export let QuartzClient = new _QuartzClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}